import { InputLabel, MenuItem, Select, Typography } from "@mui/material";

const AddBalanceSourceSelector = ({
  sources,
  source,
  onSourceChange,
  label,
  required,
}) => {
  return (
    <>
      <InputLabel
        variant="standard"
        sx={{
          width: "100%",
          margin: "3px 0px",
        }}
      >
        <Typography variant="h6" color="primary" fontSize="15px">
          {label}
        </Typography>
      </InputLabel>
      <Select
        fullWidth
        value={source}
        onChange={(e) => {
          onSourceChange(e.target.value);
        }}
        variant="outlined"
        margin="none"
        label="Hotel"
        sx={{
          margin: "8px 0px",
        }}
        required={Boolean(required)}
        style={{
          marginLeft: "1px",
        }}
      >
        {sources.map((sr) => {
          return (
            <MenuItem key={sr} value={sr}>
              {sr}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default AddBalanceSourceSelector;
